import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { phoneQueryKeys } from './queryKeys';

const getCalls = async () => {
  return await request.get(
    `/Phone/calls`,
    {},
    'При загрузке активных и непринятых звонков произошла ошибка'
  );
};

const useCalls = (options) =>
  useQuery(phoneQueryKeys.calls(), getCalls, options);

export default useCalls;
